/**
 * PreviewRenderer - рендерит секции для генерации скриншотов
 * Создаёт чистый рендер без UI редактора
 */
import React, { forwardRef } from 'react';
import { getSectionComponent } from '../sections';
import { getThemeStyles } from '../lib/themes';

const PreviewRenderer = forwardRef(({ sections, theme = 'default', style }, ref) => {
  const themeStyles = getThemeStyles(theme);

  const renderSection = (section) => {
    const Component = getSectionComponent(section?.type);
    if (!Component) {
      return null;
    }

    return (
      <Component
        data={section?.content || {}}
        styles={section?.styles || {}}
        theme={theme}
        isPreview
      />
    );
  };

  return (
    <div
      ref={ref}
      className="bg-background"
      style={{
        ...themeStyles,
        ...style,
      }}
    >
      {sections?.map((section, index) => (
        <div key={section?.id || index}>
          {renderSection(section)}
        </div>
      ))}
    </div>
  );
});

PreviewRenderer.displayName = 'PreviewRenderer';

export default PreviewRenderer;
